import React from 'react';
import styled from "styled-components";

const SGrammarImperativo = styled.div`
  flex: 1;
  padding: 5px 20px;
  td { padding: 5px; }
`;

const GrammarImperativo = () => {
  return (
    <SGrammarImperativo>
<h5>Modo Imperativo - Tryb rozkazujący</h5>

<p>
Ten tryb ma tylko 5 osób (nie ma 1 osoby liczby pojedynczej).<br/>
2 osoba liczby pojedynczej (ty) jest taka sama jak 3 osoba liczby pojedynczej trybu oznajmującego.<br/>
2 osobę liczby mnogiej (wy) tworzy się zamieniając na -d końcówkę -r z bezokolicznika.<br/>
Pozostałe osoby mają jednakowe formy jak w trybie subjuntivo (łącznym).<br/>
W 3 osobie liczby pojedynczej i mnogiej oraz w 1 osobie liczby mnogiej formy dla <i>afirmativo</i> są takie same jak dla <i>negativo</i>.
</p>

<p><b>Imperativo Afirmativo</b><br/>
<table>
<tr><td>&nbsp;</td>                <td><u>habl<b>ar</b></u></td><td><u>com<b>er</b></u></td><td><u>viv<b>ir</b></u></td></tr>
<tr><td>(tú)</td>           <td>habl<b>-a</b></td>		<td>com<b>-e</b></td>		<td>viv<b>-e</b></td></tr>
<tr><td>(él/ella/Vd.)</td>  <td>habl<b>-e</b></td>		<td>com<b>-a</b></td>		<td>viv<b>-a</b></td></tr>
<tr><td>(nosotros/-as)</td>        <td nowrap>habl<b>-emos</b></td>	<td nowrap>com<b>-amos</b></td>	<td nowrap>viv<b>-amos</b></td></tr>
<tr><td>(vosotros/-as)</td>        <td>habl<b>-ad</b></td>		<td>com<b>-ed</b></td>		<td>viv<b>-id</b></td></tr>
<tr><td nowrap>(ellos/-as/Vds.)</td>      <td>habl<b>-en</b></td>		<td>com<b>-an</b></td>		<td>viv<b>-an</b></td></tr>
</table>
</p>

<p><b>Imperativo Negativo</b><br/>
<table>
<tr><td>&nbsp;</td>                <td><u>habl<b>ar</b></u></td><td><u>com<b>er</b></u></td><td><u>viv<b>ir</b></u></td></tr>
<tr><td>(tú)</td><td><b>no</b> habl<b>-es</b></td>	<td><b>no</b> com<b>-as</b></td><td><b>no</b> viv<b>-as</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td><b>no</b> habl<b>-e</b></td><td><b>no</b> com<b>-a</b></td><td><b>no</b> viv<b>-a</b></td></tr>
<tr><td>(nosotros/-as)</td><td nowrap><b>no</b> habl<b>-emos</b></td><td nowrap><b>no</b> com<b>-amos</b></td><td nowrap><b>no</b> viv<b>-amos</b></td></tr>
<tr><td>(vosotros/-as)</td><td><b>no</b> habl<b>-éis</b></td>	<td><b>no</b> com<b>-áis</b></td><td><b>no</b> viv<b>-áis</b></td></tr>
<tr><td nowrap>(ellos/-as/Vds.)</td><td><b>no</b> habl<b>-en</b></td><td><b>no</b> com<b>-an</b></td><td><b>no</b> viv<b>-an</b></td></tr>
</table>
</p>
    </SGrammarImperativo>
    )
};

export default GrammarImperativo;